import React, { FC, useState } from 'react';
import { UITextbox } from '../../components/controls/ui/UITextbox/UITextbox';
import { InstallDialogProps } from '../../scripts/app';
import { ConnectStep } from '../generic/Components';
import { SimpleAPIKeyInstall } from '../generic/SimpleAPIKeyInstall';

export const AppInstallModal: FC<InstallDialogProps> = ({
  app,
  isOrg,
  onClose,
  open,
}) => {
  const [teamSlug, setTeamSlug] = useState('');

  return (
    <SimpleAPIKeyInstall
      app={app}
      credentialName="Personal Access Token (PAT)"
      initialApiKeyInstructions={
        <p>
          <p>
            Generate a Personal Access Token (PAT). Follow{' '}
            <a
              href="https://stackoverflowteams.help/en/articles/4385859-stack-overflow-for-teams-api#:~:text=API%20call%20header.-,The%20PAT%20interface,-To%20create%20and"
              rel="noreferrer"
              target="_blank"
            >
              these
            </a>{' '}
            instructions to manage your PAT tokens.
          </p>
          <strong>
            Dashworks requires read-only access to your team. We advise you to
            keep the expiration date to "No expiration" for a smooth experience.
          </strong>
        </p>
      }
      instructionSteps={
        <ConnectStep step={1} title="Enter team slug">
          <p>
            Your Team slug is part of the URL of your Teams instance:
            <div>
              https://stackoverflow.com/c/<strong>my-team-slug</strong>/
            </div>
          </p>
          <div className="stepField">
            <UITextbox
              className="stepFieldInput"
              onChange={setTeamSlug}
              placeholder="my-team-slug"
              size="large"
              type="text"
              value={teamSlug}
            />
          </div>
          <p className="note">
            <a
              href="https://stackoverflowteams.com/users/login"
              rel="noreferrer"
              target="_blank"
            >
              Open Stack Overflow for Teams{' '}
            </a>
          </p>
        </ConnectStep>
      }
      isOrg={isOrg}
      onClose={onClose}
      open={open}
      stepCount={1}
      suppressApiError
      teamSlug={teamSlug}
    />
  );
};
